import React from 'react';

import ArticleCreate from '../articles/ArticleCreate';

const NewsCreate = props => (
	<ArticleCreate {...props} record={{ category: 'news' }} />
);

export default NewsCreate;
